import { IRequest } from '@r1-frontend/shared/types/IRequest';

import type { RequestDto } from './dto/RequestDto';
export type { RequestDto };
export type {
    IChannel,
    IChannelCategory,
    IChannelCount,
    IChannelData,
    IChannelInfo,
    IChannelPacket,
    ICostRa,
    ResponseDto,
} from './dto/ResponseDto';

/**
 * Получение списка пакетов каналов
 * https://master.api-profile.sandbox.d2c.r-one.io/docs/v2#/TvPackets/fd1575d319693ce27802073b35e4e1f8
 */
const getTvPackets = ({
    channels = 1,
    costRa = 1,
    packetId = 0,

    connectedInTariff = 1,
    connectedOutTariff = 1,
    canConnect = 1,

    ...queryParams
}: RequestDto): IRequest => {
    const type = [
        connectedInTariff ? 'connectedInTariff' : '',
        connectedOutTariff ? 'connectedOutTariff' : '',
        canConnect ? 'canConnect' : '',
    ];

    return ({
        uri: '/v2/tv-packets',
        method: 'GET',
        withProvider: true,
        withAuth: true,
        queryParams: {
            ...queryParams,
            channels,
            costRa,
            packetId,
            type,
        },
    });
};

export default getTvPackets;
